module.exports = __webpack_public_path__ + "img/img-13.3372a04e.png";